"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlerts = exports.AlertsProvider = exports.AlertsContext = void 0;
var react_1 = __importStar(require("react"));
var generateId_1 = require("../util/generateId");
var reducer = function (state, action) {
    switch (action.type) {
        case "NOTIFICATION":
            return __assign(__assign({}, state), { alerts: __spreadArray(__spreadArray([], __read(state.alerts), false), [
                    __assign({ mode: "notification" }, action.payload),
                ], false) });
        case "ERROR":
            return __assign(__assign({}, state), { alerts: __spreadArray(__spreadArray([], __read(state.alerts), false), [
                    __assign({ mode: "error" }, action.payload),
                ], false) });
        case "RETRACT":
            return __assign(__assign({}, state), { alerts: state.alerts.filter(function (alert) { return alert.id !== action.payload.id; }) });
    }
};
exports.AlertsContext = (0, react_1.createContext)({
    state: { alerts: [] },
    sendNotification: function () { },
    sendError: function () { },
});
var AlertsProvider = function (_a) {
    var children = _a.children;
    var _b = __read((0, react_1.useReducer)(reducer, { alerts: [] }), 2), state = _b[0], dispatch = _b[1];
    var timeouts = (0, react_1.useRef)([]);
    var sendNotification = (0, react_1.useCallback)(function (_a) {
        var body = _a.body, _b = _a.ttl, ttl = _b === void 0 ? 2500 : _b;
        var id = (0, generateId_1.generateId)();
        dispatch({ type: "NOTIFICATION", payload: { id: id, body: body } });
        timeouts.current.push(window.setTimeout(function () { return dispatch({ type: "RETRACT", payload: { id: id } }); }, ttl));
    }, []);
    var sendError = (0, react_1.useCallback)(function (_a) {
        var body = _a.body, _b = _a.ttl, ttl = _b === void 0 ? 5000 : _b;
        var id = (0, generateId_1.generateId)();
        dispatch({ type: "ERROR", payload: { id: id, body: body } });
        timeouts.current.push(window.setTimeout(function () { return dispatch({ type: "RETRACT", payload: { id: id } }); }, ttl));
    }, []);
    (0, react_1.useEffect)(function () {
        var handles = timeouts.current;
        return function () {
            handles.map(clearTimeout);
        };
    }, []);
    return (react_1.default.createElement(exports.AlertsContext.Provider, { value: { state: state, sendNotification: sendNotification, sendError: sendError } }, children));
};
exports.AlertsProvider = AlertsProvider;
var useAlerts = function () {
    var _a = (0, react_1.useContext)(exports.AlertsContext), alerts = _a.state.alerts, sendNotification = _a.sendNotification, sendError = _a.sendError;
    return { alerts: alerts, sendNotification: sendNotification, sendError: sendError };
};
exports.useAlerts = useAlerts;
//# sourceMappingURL=useAlerts.js.map